const capitalizeFirstLetter = word => {
	if (!word) return null
	return word.toString().charAt(0).toUpperCase() + word.toString().slice(1)
}
export default capitalizeFirstLetter
